<ng-select
  [appendTo]="appendTo"
  [clearable]="false"
  [formControl]="control"
  [items]="skills"
  [maxSelectedItems]="maxSelectedItems"
  [multiple]="!single"
  [ngClass]="{
    'chip-limit-reached': skillsSelectedCount == maxSelectedItems,
    'last-selected-for-deletion': lastItemSelectedForDeletion,
  }"
  [virtualScroll]="true"
  (blur)="onTouched()"
  (open)="onDropdownOpen($event)"
  #skillsNgSelect
  bindLabel="Name"
  class="skills-autocomplete"
  placeholder="e.g. HTML"
>
  <ng-template *ngIf="!single" let-clear="clear" let-items="items" ng-multi-label-tmp>
    @for (item of items; track item.SkillId; let i = $index) {
      <div [ngClass]="{ last: i === items.length - 1 }" class="ng-value skill pill">
        <span class="ng-value-label">{{ item['Name'] }}</span>
        <span class="pill-remove">
          <mat-icon (click)="clear(item)" aria-hidden="true" svgIcon="close_tiny"></mat-icon>
        </span>
      </div>
    }
  </ng-template>
  <ng-template let-index="index" let-item="item" let-search="searchTerm" ng-option-tmp>
    <div class="ng-option-label multiline">
      <div class="title">
        <span [attr.title]="item['Name']" [innerHTML]="item['Name']" [ngOptionHighlight]="search"></span>
      </div>
      <div class="subtext">
        <span>{{ item['CategoryName'] }}</span>
      </div>
    </div>
  </ng-template>
  <ng-template ng-notfound-tmp>
    <div class="skill-not-found">No skills found</div>
  </ng-template>
  @if (allowAddingSkills) {
    <ng-template ng-footer-tmp>
      @if (skillsNgSelect.searchTerm) {
        <span
          (click)="createSkill(skillsNgSelect.searchTerm)"
          class="skills-autocomplete-footer-text item-create-skill"
        >
          Add new skill &quot;{{ skillsNgSelect.searchTerm }}&quot;
        </span>
      }
      @if (!skillsNgSelect.searchTerm) {
        <span class="skills-autocomplete-footer-text skill-hint">
          Start typing to find your skill or create a custom one
        </span>
      }
    </ng-template>
  }
</ng-select>
